import { controlRadiusFromPanel } from './theme-color-utils.js';
/** Converts #RRGGBB to "R G B" for Tailwind opacity modifiers. */
export function hexToRgbTriplet(hex) {
    const normalized = hex.replace('#', '').trim();
    if (normalized.length !== 6)
        return '0 0 0';
    const r = parseInt(normalized.slice(0, 2), 16);
    const g = parseInt(normalized.slice(2, 4), 16);
    const b = parseInt(normalized.slice(4, 6), 16);
    return `${r} ${g} ${b}`;
}
/** CSS custom properties and html data-* flags for a theme. */
export function buildAppThemeStyleVars(theme) {
    const { colors, layout, borders, shadows, effects, gradients, chrome, typography } = theme;
    return {
        '--font-family-sans': typography.fontFamily.join(', '),
        '--layout-app-shell-padding': layout.appShellPadding,
        '--layout-app-shell-gap': layout.appShellGap,
        '--radius-panel': layout.panelBorderRadius,
        '--radius-control': controlRadiusFromPanel(layout.panelBorderRadius),
        '--layout-channel-sidebar-width': layout.channelSidebarWidth,
        '--layout-channel-header-height': layout.channelHeaderHeight,
        '--radius-composer': layout.composerBorderRadius,
        '--color-base-deepest': hexToRgbTriplet(colors.base.deepest),
        '--color-base-deep': hexToRgbTriplet(colors.base.deep),
        '--color-base': hexToRgbTriplet(colors.base.DEFAULT),
        '--color-brand-50': hexToRgbTriplet(colors.brand[50]),
        '--color-brand-100': hexToRgbTriplet(colors.brand[100]),
        '--color-brand-200': hexToRgbTriplet(colors.brand[200]),
        '--color-brand-300': hexToRgbTriplet(colors.brand[300]),
        '--color-brand-400': hexToRgbTriplet(colors.brand[400]),
        '--color-brand-500': hexToRgbTriplet(colors.brand[500]),
        '--color-brand-600': hexToRgbTriplet(colors.brand[600]),
        '--color-brand-700': hexToRgbTriplet(colors.brand[700]),
        '--color-brand-800': hexToRgbTriplet(colors.brand[800]),
        '--color-brand-900': hexToRgbTriplet(colors.brand[900]),
        '--color-accent-violet': hexToRgbTriplet(colors.accent.violet),
        '--color-accent-purple': hexToRgbTriplet(colors.accent.purple),
        '--color-accent-blue': hexToRgbTriplet(colors.accent.blue),
        '--color-accent-cyan': hexToRgbTriplet(colors.accent.cyan),
        '--color-surface-900': hexToRgbTriplet(colors.surface[900]),
        '--color-surface-800': hexToRgbTriplet(colors.surface[800]),
        '--color-surface-700': hexToRgbTriplet(colors.surface[700]),
        '--color-surface-600': hexToRgbTriplet(colors.surface[600]),
        '--color-surface-500': hexToRgbTriplet(colors.surface[500]),
        '--color-surface-400': hexToRgbTriplet(colors.surface[400]),
        '--border-subtle': borders.subtle,
        '--border-medium': borders.medium,
        '--border-strong': borders.strong,
        '--shadow-panel': chrome.enableDepthShadows ? shadows.depthPanel : 'none',
        '--shadow-glow-violet': shadows.glowViolet,
        '--shadow-glow-blue': shadows.glowBlue,
        '--shadow-app-shell': chrome.enableAppShellBorder ? shadows.appShell : 'none',
        '--shadow-channel-row-active': chrome.enableDepthShadows
            ? shadows.channelRowActive
            : 'none',
        '--shadow-composer-focus': chrome.enableDepthShadows ? shadows.composerFocus : 'none',
        '--shadow-depth-panel': chrome.enableDepthShadows ? shadows.depthPanel : 'none',
        '--shadow-depth-button': chrome.enableDepthShadows ? shadows.depthButton : 'none',
        '--shadow-depth-control': chrome.enableDepthShadows ? shadows.depthControl : 'none',
        '--effect-ambient-blur': effects.ambientOrbBlur,
        '--effect-ambient-opacity': String(effects.ambientOrbOpacity),
        '--color-ambient-violet': effects.ambient.violet,
        '--color-ambient-purple': effects.ambient.purple,
        '--color-ambient-blue': effects.ambient.blue,
        '--color-ambient-cyan': effects.ambient.cyan,
        '--scrollbar-thumb': effects.scrollbarThumb,
        '--scrollbar-thumb-hover': effects.scrollbarThumbHover,
        '--transition-premium-ms': `${effects.premiumTransitionMs}ms`,
        '--gradient-banner-overlay': gradients.serverBannerOverlay,
        '--gradient-banner-glow': gradients.serverBannerGlow,
        '--gradient-composer-glow': gradients.composerGlow,
        '--chrome-panel-sidebar-bg': chrome.panelSidebarBg,
        '--chrome-panel-chat-bg': chrome.panelChatBg,
        '--chrome-panel-members-bg': chrome.panelMembersBg,
        '--chrome-panel-backdrop-blur': chrome.panelBackdropBlur,
    };
}
export function buildAppThemeDomDataset(theme) {
    const { chrome } = theme;
    return {
        theme: theme.id,
        chromeAmbient: chrome.enableAmbientLights ? '1' : '0',
        chromeComposerGlow: chrome.enableComposerGlow ? '1' : '0',
        chromeAppShell: chrome.enableAppShellBorder ? '1' : '0',
        chromeDepth: chrome.enableDepthShadows ? '1' : '0',
    };
}
//# sourceMappingURL=apply-theme-vars.js.map